/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { UserManager } from '@forgerock/javascript-sdk';
// import { isNil } from 'lodash';
import isNil from 'lodash/isNil';
import { useEffect, useState } from 'react';
import RequestRoleResource from '../components/forms/RoleRequest/requestRoleResource';
import RoleRequestSelectOrgEngine from '../components/forms/RoleRequest/RoleRequestSelectOrg';
import SuccessPage from '../components/forms/RoleRequest/SuccessPage';
import SuccessErrorModal, { MessageType } from '../components/modals/SuccessErrorModal';
import idmRequest from '../lib/idmRequest';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { isLoggedInSelector } from '../redux/loginSlice';
import {setRoleResourceData,setStage, setIsAlertOpen, setMessage, setMessageType,userRoleSelector } from '../redux/userRolesSlice';
import styles from '../styles/Home.module.css';
import Suspendstyles from '../styles/SuspendedMessage.module.css';
import { useNavigate } from "react-router-dom";
import modalStyle from '../styles/SuccessError.module.css';
import isEmpty from 'lodash/isEmpty'
import { includes } from 'lodash';


const RoleRequestPage = () => {

  const navigate = useNavigate();
  const [engineOrgData, setEngineOrgData] = useState<any>();
  const [alertOpen,setAlertopen] = useState<boolean>()
   
  const [chosenOrgEngineData, setChosenOrgEngineData] = useState<{ engineModelName?: string[], companyId: any }>();
  const [roleResourceSelectedData, setRoleResourceSelectedData] = useState<any>();

  //store Variables
  const {user} = useAppSelector(isLoggedInSelector);
  const dispatch = useAppDispatch();
  const { roleResourceData, stage ,isAlertOpen , message, messageType} = useAppSelector(userRoleSelector);

  const handleOpen = () => {
    dispatch(setIsAlertOpen(true));
    setAlertopen(true) 
  };
  const handleClose = () => {
    dispatch( setIsAlertOpen(false));
    setAlertopen(false)
  };

  useEffect(() => {
    (async () => {
      try {
        await getOrganizationEnginerModelData();
      } catch (e) {
        console.error(e);
      }
    })();
  }, [])

  useEffect(() => {
    (async () => {
      try {
        if (!isNil(chosenOrgEngineData)) {
          await getRoleResourceData();
        }
      } catch (e) {
        console.error(e);
      }
    })();
    
  }, [chosenOrgEngineData])

  const submitData = async (data: any): Promise<any> => {
    const response = await idmRequest('/workflow/processinstance?_action=create', 'post', data);
    if (response.error) {
      dispatch(setIsAlertOpen(true));
      setAlertopen(true)
      if(response.error.includes("Company Admins are not active.please reject the request with a reason.")){
        dispatch(setMessageType(MessageType.error))
        dispatch(setMessage("You cannot request a resource because your company has no active Client Admin currently. Please reach out to <a href='mailto:portalidentity@prattwhitney.com' >portalidentity@prattwhitney.com</a>."))
      } else {
        dispatch(setMessageType(MessageType.error))
        dispatch(setMessage('Something went wrong. Please try again.'))
      }
    } else {
      dispatch( setIsAlertOpen(false));
      dispatch(setStage('Success'));
      setAlertopen(false)
    }
  };

  useEffect(() => {
    (async () => {
      if (!isNil(roleResourceSelectedData)) {
        let data = {}
        for (let i=0;i<roleResourceSelectedData.iterations;i++){
          // console.log("in forloop " , i)
          if(!isEmpty(chosenOrgEngineData?.engineModelName)){
            data = {
              "_key": "roleRequest",
              "role": roleResourceSelectedData?.[`role ${i}`],
              "organization": chosenOrgEngineData?.companyId,
              "payerCode": roleResourceSelectedData?.[`payerCode ${i}`],
              "etoolingCode": roleResourceSelectedData?.[`etoolingCode ${i}`],
              "engineModel": chosenOrgEngineData?.engineModelName,
              "ataCode": roleResourceSelectedData?.[`ataCode ${i}`],
              "ehmCode": roleResourceSelectedData?.[`ehmCode ${i}`],
              "soldToCode": roleResourceSelectedData?.[`soldToCode ${i}`],
              "eLicensingCode": roleResourceSelectedData?.[`eLicensingCode ${i}`],
              "soldToCodeType": roleResourceSelectedData?.[`soldToCodeType ${i}`],
              'reason': roleResourceSelectedData.comments,
              "email": (user as any).email
            }
          } else {
            data = {
              "_key": "roleRequest",
              "role": roleResourceSelectedData?.[`role ${i}`],
              "organization": chosenOrgEngineData?.companyId,
              "payerCode": roleResourceSelectedData?.[`payerCode ${i}`],
              "etoolingCode": roleResourceSelectedData?.[`etoolingCode ${i}`],
              "engineModel": [],
              "ataCode": roleResourceSelectedData?.[`ataCode ${i}`],
              "ehmCode": roleResourceSelectedData?.[`ehmCode ${i}`],
              "soldToCode": roleResourceSelectedData?.[`soldToCode ${i}`],
              "eLicensingCode": roleResourceSelectedData?.[`eLicensingCode ${i}`],
              "soldToCodeType": roleResourceSelectedData?.[`soldToCodeType ${i}`],
              'reason': roleResourceSelectedData.comments,
              "email": (user as any).email
            }
            
          }
          // console.log(data)
          submitData(data);
        }
      }

    })();
  }, [roleResourceSelectedData])

  const getOrganizationEnginerModelData = async () => {
    const engineOrgMap = new Map();
    const data = await idmRequest('/endpoint/getUserEngCompany', 'get');
    if (!isNil(data) && !isNil(data.engineModelsInfo)) {
      dispatch(setIsAlertOpen(false))
      setAlertopen(false)
      data.engineModelsInfo.forEach((info: any) => {
        engineOrgMap.set(info.engineModel, info.organization)
      })
      setEngineOrgData({ engineOrgMap: engineOrgMap, org: data.organizationInfo });
    }
    else {
      dispatch(setIsAlertOpen(true));
      setAlertopen(true)
      dispatch(setMessage('Failed to load organization and engine Models'));
    }
  }


  const getRoleResourceData = async () => {
    const resourceName = new Set();
    const roles =new Set();
    const roleData = new Map<string, { value: any, name: string , displayName: any}[]>()
    const codeTypeRoleMap = new Map<string, string[]>()
    let etoolingCodes = [];
    let payerCodes = [];
    let url = '/endpoint/getUserRolesRequest'
    const data = await idmRequest(url, 'post', chosenOrgEngineData);
    if (!isNil(data) && !isNil(data.rolesInfo)) {
      dispatch(setIsAlertOpen(false));
      setAlertopen(false);
      payerCodes = data.payerCode;
      etoolingCodes = data.etoolingCode;
      let roleDataList: { value: any, name: string , displayName : string }[] | undefined = [];
      let codeTypeList: string[] | undefined = [];
      data.rolesInfo.forEach((info: any) => {
        resourceName.add(info.resourceName)
        roles.add(info.name);
        codeTypeRoleMap.set(info._id, info.codeType)
        roleDataList = roleData.get(info.resourceName);
        if (roleDataList) {
          roleDataList.push({ value: info._id, name: info.name, displayName : info.displayName })
        } else {
          roleDataList = [{ value: info._id, name: info.name,  displayName : info.displayName }]
        }
        roleData.set(info.resourceName, roleDataList)

      })
      dispatch(setRoleResourceData({ resourceName: resourceName, roles:roles, payerCodes: payerCodes, etoolingCodes: etoolingCodes, codeTypeRoleMap: codeTypeRoleMap, roleDataMap: roleData, data: data }));
      dispatch(setStage('RoleResource'));
      
    } else {
      dispatch(setIsAlertOpen(true));
      setAlertopen(true)
      dispatch(setMessage('Failed to load Resources'));
    }


  }

  const getNextStepHtml = () => {
    return (

<>

        <p className={Suspendstyles.nextStepDescription}>{"Your request to gain additional access has been successfully submitted and is currently being reviewed. You can check the status of your request via this "}<a style={{textDecoration:"none"}} onClick={()=>{navigate("/roleRequest?tab=myResources")}} >link</a>{".You can use the Add role to add more roles for the user."} </p>
</>
    )
      
      // return(<></>)
  }


  return (
    <>
  <main className={styles.protectedMain}> 
        {stage === 'RoleResource' && <RequestRoleResource alertOpen={alertOpen} setRoleResourceSelectedData={setRoleResourceSelectedData} />}
        {stage === 'OrgEngine' && <RoleRequestSelectOrgEngine engineOrgData={engineOrgData} setChosenOrgEngineData={setChosenOrgEngineData} />}
        {stage === 'Success' && <SuccessPage button={<button className={`accent-1`} style={{ width: '100%',minHeight:"40px" }} 
        onClick={() => dispatch(setStage('OrgEngine'))}>Add More Role</button>} header={'Role Requested Successfully'} 
        description="Thank you for requesting the Role" 
        // nextStepMessage=
        // {'Your request to gain additional access has been successfully submitted and is currently being reviewed. You can check the status of your request via this link <a style="color:blue" onClick={()=>{navigate("/roleRequest?tab=resourceDescriptions")}} >My Resources</a>.You can use the Add role to add more roles for the user'}
        nextStepMessageHTML={getNextStepHtml()}
        //<p className={Suspendstyles.nextStepDescription}
        ></SuccessPage>}


      </main>
    </>);

};

export default RoleRequestPage;